import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'

const NewsItem = ({news, isScrollBar}) => {
	const { theme, mdDown } = useDefaultComponentTools()
	const mr = mdDown ? '10px' : '15px'

	return (

		<Box sx={{borderBottom: theme.palette.border, mr: isScrollBar ? mr : 0, p: '15px'}}>
			<Typography  sx={{ fontSize: '16px'}}>{news.title}</Typography>
			<Typography sx={{fontSize: '12px', p: '10px 0', textAlign: 'justify'}}>{news.text}</Typography>
			<Typography sx={{ fontSize: '13px'}}>{news.date}</Typography>
		</Box>
	)
}

NewsItem.propTypes = {
	isScrollBar: PropTypes.bool,
	news: PropTypes.object
}

export default NewsItem
